module.exports = "https://deal.freetls.fastly.net/consumer/common/media/step-1.98df77a1.mp4";